import TablaYounet from '../Elementos/TablaYounet';


const Tecnologia =()=>{

    const headCellsColumn = [
        { id: 'Tecnologia', numeric: false, disablePadding: false, label: 'TECNOLOGIA', show:true, fixed:false, width:200, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
    ];

    const variablesObject = {      
        api:'/api/Tecnologias',
        apiMultiples:'/api/Tecnicos/multiple',
        isButtonAdd:true,
        isUpperCase:false,
        isMultiline:false,
        label:'TECNOLOGIA',
        nameLocalStorage:'headersTecnologiasAC',
        order:'asc',
        orderBy:'Tecnologia',
        OptionSearch:'Tecnologia',
        rowsPerPage:15,
        Ruta:'/Almacen/Tecnologia',
        sumWidth:360,
        title:'Tecnologias',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Tecnologia;